import { AfterContentInit, Component, Input } from '@angular/core'

@Component({
    selector: 'app-initials',
    templateUrl: 'initials.html'
})
export class InitialsComponent implements AfterContentInit {
    @Input() displayName: string
    initials: string

    // Public
    ngAfterContentInit() {
        this.initials = this.displayName?.length ? this.displayName[0] : ''
    }
}
